import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { setMapViewDialogOpen } from '@user/store/map/slice'
import type { UseData } from './useData'

export function useHandlers(data: UseData) {
  const dispatch = useDispatch()
  const { open } = data

  const onClose = useCallback(() => {
    dispatch(setMapViewDialogOpen({ open: false }))
  }, [dispatch])

  const onOpen = useCallback(() => {
    dispatch(setMapViewDialogOpen({ open: true, source: 'sidenav' }))
  }, [dispatch])

  return {
    open,
    onClose,
    onOpen,
  }
}
